import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../environments/environment";

import { EvaluationCompetence } from "../model/avalicorp/EvaluationCompetenceModel";
import { EvaluationDiscursiveQuestion } from "../model/avalicorp/EvaluationDiscursiveQuestionModel";
import { EvaluationAnswer } from "../model/avalicorp/EvaluationAnswerModel";

import { AppliedEvaluationStatus } from "./applied-evaluation-status-constant";

import _ from "lodash";

@Injectable()
export class RealizeEvaluationService {
  constructor(private http: HttpClient) {}

  public listAllAnswers(): Observable<EvaluationAnswer[]> {
    return this.http.get<EvaluationAnswer[]>(
      environment.apiHost + "/avalicorp/administration/questions/answers"
    );
  }

  public getQuestionsByCompetence(
    appliedEvaluationId: number,
    userId: number
  ): Observable<EvaluationCompetence[]> {
    return this.http.get<EvaluationCompetence[]>(
      environment.apiHost +
        "/realize/evaluation/appliedEvaluation/" +
        appliedEvaluationId +
        "/user/" +
        userId
    );
  }

  public findEvaluationQuestionsByAppliedIdAndUserId(
    appliedEvaluationId: number,
    userId: number
  ): Observable<EvaluationDiscursiveQuestion[]> {
    return this.http.get<EvaluationDiscursiveQuestion[]>(
      environment.apiHost +
        "/realize/evaluation/questions/appliedEvaluation/" +
        appliedEvaluationId +
        "/user/" +
        userId
    );
  }

  public conclude(appliedEvaluationId: number, userId: number) {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http
      .put(
        environment.apiHost +
          "/realize/evaluation/conclude/appliedEvaluation/" +
          appliedEvaluationId +
          "/user/" +
          userId,
        {},
        { headers: headers, responseType: "text" }
      )
      .map((response) => response);
  }

  public saveResultQuestion(result) {
    let headers = new HttpHeaders({
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json;charset=utf-8",
    });
    return this.http
      .post(
        environment.apiHost + "/avalicorp/evaluation/results/save",
        result,
        { headers: headers, responseType: "text" }
      )
      .map((response) => JSON.parse(response));
  }

  public getResultToSave(question, appliedEvaluation, userId) {
    return {
      id: question.resultId,
      clientId: appliedEvaluation.clientId,
      answer: question.answer,
      answerId: question.answerId,
      appliedEvaluationId: appliedEvaluation.id,
      competenceId: question.competenceId,
      questionId: question.id,
      userId: userId,
      isAlignment: false,
      isSelfEvaluation:
        appliedEvaluation.hasSelfEvaluation &&
        appliedEvaluation.usersProcess.evaluated.status !=
          AppliedEvaluationStatus.CONCLUIDO,
    };
  }

  public getValidators = function (applied) {
    return {
      showEvaluatedComments: _.some(
        applied.evaluation.questions,
        "showEvaluatedComments"
      ),
      showEvaluatorComments:
        _.some(applied.evaluation.questions, "showEvaluatorComments") &&
        (applied.evaluatorQuestions || []).length > 0,
      isEvaluatedComment: !_.some(
        applied.evaluation.questions,
        "isSelfEvaluation"
      ),
      editEvaluatedComments: _.every(
        applied.evaluation.questions,
        "editEvaluatedComments"
      ),
      editEvaluatorComments: _.every(
        applied.evaluation.questions,
        "editEvaluatorComments"
      ),
    };
  };

  public setDiscursiveQuestions(applied) {
    return new Promise((resolve, reject) => {
      if (
        applied.hasSelfEvaluation &&
        applied.usersProcess.evaluated.status !=
          AppliedEvaluationStatus.CONCLUIDO
      ) {
        applied.evaluatedQuestions = this.getEvaluationQuestions(
          applied.evaluation,
          true
        );
        return resolve(applied);
      }

      applied.evaluatorQuestions = this.getEvaluationQuestions(
        applied.evaluation,
        false
      );
      applied.evaluatedQuestions = this.getEvaluationQuestions(
        applied.evaluation,
        true
      );
      return resolve(applied);
    });
  }

  public getCompetenceQuestion(evaluation, callback) {
    evaluation.competencies.forEach((competence) => {
      competence.questions.forEach((question) => {
        callback(competence, question);
      });
    });
  }

  public getEvaluationQuestions(evaluation, isSelfEvaluation) {
    return _.orderBy(
      _.filter(evaluation.questions, { isSelfEvaluation: isSelfEvaluation }),
      ["position"],
      ["asc"]
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/realize-evaluation-service.ts